import { config } from '@/_config';

import { ApiClient } from './api-client';

export const apiClient = new ApiClient({ baseUrl: config.baseURL[0] });
export const apiClientAod = new ApiClient({ baseUrl: config.baseURL[1] });
export const moodleClient = new ApiClient({ baseUrl: config.moodleBaseUrl });
